<div class="movement-section">
  <div class="row h-100 d-flex align-items-stretch">
    @if (firstMovement()) {
      <div class="col-12 d-flex align-items-start" [ngClass]="(firstMovement().arrivalStatus) + (firstMovement().date || plain() ? '' : ' text-muted ')">
        <div class="row gx-2 w-100">
          <app-tooltip class="col-auto d-flex align-items-center" [placement]="'top'" [disabled]="!firstMovement().tooltip">
            @if (plain()) {
              <i class="fa fa-light" [ngClass]="hasMiddleRow() ? 'fa-arrow-right' : 'fa-arrow-up'"></i>
            } @else {
              <i class="movement-icon fa fa-solid" [ngClass]="hasMiddleRow() ? 'fa-circle-arrow-right' : 'fa-circle-arrow-up'"></i>
            }
            <div class="tooltipContent">
              <div class="tooltip-card">
                <div class="tooltip-card-body">
                  {{ firstMovement().tooltip }}
                </div>
              </div>
            </div>
          </app-tooltip>
          @if (showDate()) {
            <span class="col-auto arrival-date">{{ (firstMovement().date | date:'dd MMM HH:mm') || 'No date' }}</span>
          }
          <span class="col text-truncate">
            <app-highlight [term]="term()" [result]="firstMovement().name"></app-highlight>
          </span>
        </div>
      </div>
    }
    @if (currentMiddleMovements()?.length) {
      @for (movement of currentMiddleMovements(); track movement) {
        <div class="col-12 d-flex align-items-center" [ngClass]="movement.arrivalStatus">
          @if (showAsRows()) {
            <div class="row g-0 me-2">
              <app-tooltip class="col-auto d-flex align-items-center" [placement]="'top'" [disabled]="!movement.tooltip">
                @if (middleStatus() === 'arrived') {
                  <div class="movement-icon">
                    <div class="movement-arrived"></div>
                  </div>
                } @else {
                  <i class="movement-icon fa fa-solid fa-circle-dot" [ngClass]="(!!movement.date || plain() ? '' : ' text-muted ')"></i>
                }
                <div class="tooltipContent">
                  <div class="tooltip-card">
                    <div class="tooltip-card-body">
                      {{ movement.tooltip }}
                    </div>
                  </div>
                </div>
              </app-tooltip>
            </div>
            <div class="row g-0 w-100">
              @if (showDate()) {
                <span class="col-12 arrival-date" [ngClass]="(!!movement.date || plain() ? '' : ' text-muted ')">
                  {{ (movement.date | date:'dd MMM HH:mm') || 'No date' }}
                </span>
              }
              <div class="col-12 position-relative" [style.height.rem]="1.5">
                <div class="position-absolute d-flex align-items-center h-100 w-100 pe-2">
                  <span class="me-2 text-truncate" style="min-width: 0" [ngClass]="(!!movement.date || plain() ? '' : ' text-muted ')">
                    <app-highlight [term]="term()" [result]="movement.name"></app-highlight>
                  </span>
                  @if (showMore()) {
                    <button onPopover class="btn btn-outline-info p-1 px-2" style="min-width: 33px"
                            data-bs-toggle="popover" [popoverContent]="movementsPopover" [placement]="'top'"
                            aria-describedby="tooltip" popoverClass="pop-auto-container position-fixed" [popoverData]="middleMovements()">
                      <span class="text-primary">+{{middleMovements().length - 1}}</span>
                    </button>
                  }
                </div>
              </div>
            </div>
          } @else {
            <div class="row gx-2 w-100">
              <app-tooltip class="col-auto d-flex align-items-center" [placement]="'top'" [disabled]="!movement.tooltip">
                @if (middleStatus() === 'arrived') {
                  <div class="movement-icon">
                    <div class="movement-arrived"></div>
                  </div>
                } @else {
                  <i class="movement-icon fa fa-solid fa-circle-dot" [ngClass]="(!!movement.date || plain() ? '' : ' text-muted ')"></i>
                }
                <div class="tooltipContent">
                  <div class="tooltip-card">
                    <div class="tooltip-card-body">
                      {{ movement.tooltip }}
                    </div>
                  </div>
                </div>
              </app-tooltip>
              @if (showDate()) {
                <span class="col-auto arrival-date" [ngClass]="(!!movement.date || plain() ? '' : ' text-muted ')">
              {{ (movement.date | date:'dd MMM HH:mm') || 'No date' }}
            </span>
              }
              <div class="col position-relative">
                <div class="position-absolute d-flex align-items-center h-100 w-100 pe-2">
              <span class="me-2 text-truncate" style="min-width: 0" [ngClass]="(!!movement.date || plain() ? '' : ' text-muted ')">
                <app-highlight [term]="term()" [result]="movement.name"></app-highlight>
              </span>
                  @if (showMore()) {
                    <button onPopover class="btn btn-outline-info p-1 px-2" style="min-width: 33px"
                            data-bs-toggle="popover" [popoverContent]="movementsPopover" [placement]="'top'"
                            aria-describedby="tooltip" popoverClass="pop-auto-container position-fixed" [popoverData]="middleMovements()">
                      <span class="text-primary">+{{middleMovements().length - 1}}</span>
                    </button>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    }
    @if (lastMovement()) {
      <div class="col-12 d-flex align-items-end" [ngClass]="(lastMovement().arrivalStatus) + (lastMovement().date || plain() ? '' : ' text-muted ')">
        <div class="row gx-2 w-100">
          <app-tooltip class="col-auto d-flex align-items-center" [placement]="'top'" [disabled]="!lastMovement().tooltip">
            @if (plain()) {
              <i class="fa fa-light" [ngClass]="(middleMovements()?.length === 0 && hasMiddleRow() ? ' no-middle-movement ' : '') + (hasMiddleRow() ? ' fa-arrow-left ' : ' fa-arrow-down ')"></i>
            } @else {
              <i class="movement-icon fa fa-solid" [ngClass]="(middleMovements()?.length === 0 && hasMiddleRow() ? ' no-middle-movement ' : '') + (hasMiddleRow() ? ' fa-circle-arrow-left ' : ' fa-circle-arrow-down ')"></i>
            }
            <div class="tooltipContent">
              <div class="tooltip-card">
                <div class="tooltip-card-body">
                  {{ lastMovement().tooltip }}
                </div>
              </div>
            </div>
          </app-tooltip>
          @if (showDate()) {
            <span class="col-auto arrival-date">{{ (lastMovement().date | date:'dd MMM HH:mm') || 'No date' }}</span>
          }
          <span class="col text-truncate">
            <app-highlight [term]="term()" [result]="lastMovement().name"></app-highlight>
          </span>
        </div>
      </div>
    }
  </div>
</div>

<ng-template #movementsPopover let-data="$implicit">
  <div class="movement-section text-nowrap p-1 pe-4 flex-row" [style.max-width.px]="320">
    <div class="btn-close-wrapper rounded-circle position-absolute end-0 top-0 mt-2 me-2">
      <button type="button" class="btn-close" data-bs-toggle="popover" aria-label="Close"></button>
    </div>
    <div class="row flex-column">
      @for (movement of data; track movement; let i = $index) {
        <div class="col-12" [ngClass]="movement.arrivalStatus">
          <div class="row gx-2 flex-nowrap" [ngClass]="(!!movement.date || plain() ? '' : ' text-muted ')">
            @if (movement.arrivalStatus === 'arrived') {
              <div class="col-auto movement-icon" [ngClass]="i === 0 ? 'no-pseudo': ''">
                <div class="movement-arrived"></div>
              </div>
            } @else {
              <i class="col-auto movement-icon fa fa-solid fa-circle-dot" [ngClass]="i === 0 ? 'no-pseudo': ''"></i>
            }
            <span class="col-auto arrival-date">
              {{ (movement.date | date:'dd MMM HH:mm') || 'No date' }}
            </span>
            <div class="col text-truncate">
              <span>
                {{movement.name}}
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
